/* MCD Wing-PDP (W3-Port des Prototyps R21, 2026-07-12).
   Aenderungen ggue. Prototyp: toter Hero-/Story-Linien-Code entfernt, Spin-Frame-
   und Foto-URLs aus dem JSON-Island #mcd-pdp-data (Shopify-CDN), Cursor-Glitch
   ueber das geteilte Modul (Jonas 12.07.), Waitlist = echtes Kundenformular mit
   dynamischen Tags (Version + Finish der aktuellen Auswahl). */
(function(){
  /* Fallback, falls mcd-ui.js (Baukasten) nicht geladen ist: ohne Einrasten weiterlaufen */
  window.MCD=window.MCD||{};MCD.beat=MCD.beat||function(p){return p;};
  const R=document.querySelector(".mcd-pdp");
  if(!R)return;
  let CFG;
  try{
    CFG=JSON.parse(document.getElementById("mcd-pdp-data").textContent);
  }catch(e){
    /* Ohne Konfig: Inhalt sichtbar lassen (Reveals sind an die body-Klasse gebunden) */
    document.body.classList.remove("mcd-pdp-page");
    document.querySelectorAll(".mcd-pdp .pre").forEach(p=>p.classList.add("done"));
    console.warn("mcd-pdp: Konfig fehlt",e);
    return;
  }
  const $=s=>R.querySelector(s), $$=s=>Array.from(R.querySelectorAll(s));
  const reduce=matchMedia("(prefers-reduced-motion:reduce)").matches;
  const touch=matchMedia("(hover:none)").matches;
  const mobile=matchMedia("(max-width:900px)").matches;
  const shoot=new URLSearchParams(location.search).get("shoot")==="1";
  const clamp=(v,a,b)=>Math.min(b,Math.max(a,v));
  const easeO=p=>1-Math.pow(1-p,3);
  /* Stabile Viewport-Hoehe (In-App-Browser 05.08.): Instagram/TikTok klappen ihre
     Leisten beim Scrollen ein/aus -> innerHeight aendert sich mitten im Scroll und
     alle vh()-basierten Effekte springen. Hoehe nur uebernehmen, wenn sich die
     Breite aendert (Rotation/echtes Resize) oder der Sprung >150px ist. */
  let _vw=innerWidth,_vh=innerHeight;
  addEventListener("resize",()=>{
    if(innerWidth!==_vw||Math.abs(innerHeight-_vh)>150){_vw=innerWidth;_vh=innerHeight;}
  });
  const vh=()=>_vh;

  /* ===== Scroll-Velocity ===== */
  let velo=0,lastY=scrollY,lastT=performance.now(),ticking=false;
  addEventListener("scroll",()=>{
    const now=performance.now(),y=scrollY;
    velo=(y-lastY)/Math.max(1,now-lastT)*16;lastY=y;lastT=now;
    if(!ticking){ticking=true;requestAnimationFrame(frame);}
  },{passive:true});
  addEventListener("resize",()=>{sizeSpin();frame();});

  /* ===== Char-Split ===== */
  function split(el){let i=0;const src=Array.from(el.childNodes);el.textContent="";
    src.forEach(n=>{if(n.nodeType===1&&n.classList.contains("ln")){const ln=document.createElement("span");ln.className="ln";
      for(const c of n.textContent){if(c===" "){ln.appendChild(document.createTextNode(" "));continue;}
        const s=document.createElement("span");s.className="ch";s.style.setProperty("--d",(i*0.018).toFixed(3)+"s");s.textContent=c;ln.appendChild(s);i++;}el.appendChild(ln);}});}
  $$(".chars").forEach(el=>{if(!reduce)split(el);});

  /* ===== Scramble ===== */
  const GLYPHS="▮▯01/\\|<>*#";
  function scramble(el){
    if(reduce||el.dataset.done)return;el.dataset.done="1";
    const final=el.textContent,t0=performance.now(),dur=850;
    (function tick(now){
      const p=clamp((now-t0)/dur,0,1);
      const solved=Math.floor(final.length*easeO(p));let out="";
      for(let i=0;i<final.length;i++){const c=final[i];
        out+=i<solved||c===" "?c:GLYPHS[(Math.random()*GLYPHS.length)|0];}
      el.textContent=out;
      if(p<1)requestAnimationFrame(tick);else el.textContent=final;
    })(t0);
  }

  /* ===== Preloader ===== */
  const pre=$("#pre"),boot=$("#preBoot"),B=["LOADING R1 AERO","CALIBRATING WINGS","READY."];let bi=0;
  const bt=setInterval(()=>{bi=Math.min(B.length-1,bi+1);boot.textContent=B[bi];if(bi===B.length-1)clearInterval(bt);},110);
  /* Perf 2026-07-25 (Jonas-GO): 900ms Vollbild-Preloader verdeckte den Hero-Text
     (= LCP-Element p.lede) komplett. 300ms reichen fuer die Marken-Optik. */
  setTimeout(()=>{pre.classList.add("done");},shoot?60:300);

  /* ===== Magnet-CTAs (Desktop) ===== */
  if(!touch&&!reduce)$$("[data-magnet]").forEach(el=>{
    let tx=0,ty=0,rx=0,ry=0;
    addEventListener("mousemove",e=>{
      const r=el.getBoundingClientRect();
      const dx=e.clientX-(r.left+r.width/2),dy=e.clientY-(r.top+r.height/2);
      const d=Math.hypot(dx,dy);
      const pull=d<130?(1-d/130)*12:0;
      tx=(dx/(d||1))*pull;ty=(dy/(d||1))*pull;
    });
    let magLast="";
    (function mag(){rx+=(tx-rx)*.18;ry+=(ty-ry)*.18;
      const t=`translate(${rx.toFixed(2)}px,${ry.toFixed(2)}px)`;
      if(t!==magLast){el.style.transform=t;magLast=t;} /* 24.09.: nur bei Bewegung schreiben */
      requestAnimationFrame(mag);})();
  });

  /* Marquee entfernt (Jonas 13.07.) */

  /* ===== Cursor-Glitch (geteiltes Modul v2, Desktop only) ===== */
  if(window.MCDGlitch&&!mobile)MCDGlitch.init({boom:false,sources:[CFG.fotoClaw,CFG.fotoShard]});

  /* ===== Reveals + Gauges ===== */
  const io=new IntersectionObserver(es=>es.forEach(e=>{if(!e.isIntersecting)return;e.target.classList.add("is-in");
    e.target.querySelectorAll("[data-scramble]").forEach(scramble);
    if(e.target.matches("[data-scramble]"))scramble(e.target);
    if(e.target._g)setTimeout(e.target._g,160);io.unobserve(e.target);}),{threshold:.2});
  /* [data-clip] startet mit clip-path 100% -> IO-Ratio 0, feuert nie. Ueber PARENT beobachten. */
  const ioClip=new IntersectionObserver(es=>es.forEach(e=>{if(!e.isIntersecting)return;
    e.target.querySelectorAll("[data-clip]").forEach(c=>c.classList.add("is-in"));
    ioClip.unobserve(e.target);}),{threshold:.12});
  if(shoot){$$("[data-reveal],[data-clip],.chars").forEach(el=>{el.classList.add("is-in");if(el._g)el._g();});setTimeout(()=>$$(".n[data-gauge]").forEach(n=>n._g&&n._g()),80);}
  else{$$("[data-reveal],.chars").forEach(el=>{if(!el.hasAttribute("data-clip"))io.observe(el);});
       $$("[data-clip]").forEach(c=>ioClip.observe(c.parentElement));
       $$(".kicker[data-scramble]").forEach(el=>io.observe(el));}

  const GA0=225,GA1=495;
  const gp=(r,d)=>{const a=(d-90)*Math.PI/180;return[50+r*Math.cos(a),56+r*Math.sin(a)];};
  const garc=(r,a0,a1)=>{const[x0,y0]=gp(r,a0),[x1,y1]=gp(r,a1);return`M ${x0.toFixed(1)} ${y0.toFixed(1)} A ${r} ${r} 0 ${a1-a0>180?1:0} 1 ${x1.toFixed(1)} ${y1.toFixed(1)}`;};
  const NS="http://www.w3.org/2000/svg";
  $$(".n[data-gauge]").forEach(n=>{
    const frac=Math.max(0,Math.min(1,parseFloat(n.dataset.gauge||"0")));
    const row=n.querySelector(".num-row");
    const svg=document.createElementNS(NS,"svg");svg.setAttribute("class","gauge");svg.setAttribute("viewBox","0 0 100 100");
    const mk=(c,d)=>{const p=document.createElementNS(NS,"path");p.setAttribute("class",c);p.setAttribute("d",d);svg.appendChild(p);return p;};
    mk("trk",garc(38,GA0,GA1-40));mk("redz",garc(38,GA1-38,GA1));
    for(let t=0;t<=4;t++){const d=GA0+(GA1-GA0)*t/4;const[x0,y0]=gp(32,d),[x1,y1]=gp(37,d);
      const l=document.createElementNS(NS,"line");l.setAttribute("class","tick");l.setAttribute("x1",x0);l.setAttribute("y1",y0);l.setAttribute("x2",x1);l.setAttribute("y2",y1);svg.appendChild(l);}
    const val=mk("val",garc(38,GA0,GA1));val.setAttribute("pathLength","100");val.style.strokeDasharray="100";val.style.strokeDashoffset="100";
    const nd=document.createElementNS(NS,"line");nd.setAttribute("class","ndl");const[nx,ny]=gp(28,GA0);nd.setAttribute("x1",50);nd.setAttribute("y1",56);nd.setAttribute("x2",nx);nd.setAttribute("y2",ny);svg.appendChild(nd);
    const hub=document.createElementNS(NS,"circle");hub.setAttribute("class","hub");hub.setAttribute("cx",50);hub.setAttribute("cy",56);hub.setAttribute("r",2.6);svg.appendChild(hub);
    row.insertBefore(svg,row.firstChild);
    n._g=()=>{val.style.strokeDashoffset=String(100*(1-frac));nd.style.transform=`rotate(${(GA1-GA0)*frac}deg)`;
      if(frac===0&&!reduce)nd.animate([{transform:"rotate(0)"},{transform:"rotate(16deg)",offset:.35},{transform:"rotate(0)"}],{duration:950,easing:"cubic-bezier(.22,1,.36,1)"});};
    if(reduce){n._g=null;val.style.strokeDashoffset=String(100*(1-frac));nd.style.transform=`rotate(${(GA1-GA0)*frac}deg)`;}
  });

  /* ===== Konfigurator. Mapping Jonas-bestaetigt: wing5=ClawV2 (launcht zuerst), wing4=ShardV2. ===== */
  const VER={
    claw:{name:"ClawV2",kick:"CLAWV2",badge:"CLAWV2 · 360°",flag:"LAUNCHING FIRST",tag:"FIRST",sub:"Finned · aggressive",
      desc:"The louder shape: layered fins for a purposeful, race-derived look. Same bonded mount, same five-minute install per side.",
      foto:CFG.fotoClaw,spin:CFG.spinClaw},
    shard:{name:"ShardV2",kick:"SHARDV2",badge:"SHARDV2 · 360°",flag:"IN DEVELOPMENT",tag:"",sub:"Clean blade · minimal",
      desc:"The quiet shape: one clean blade, minimal and slippery. Same bonded mount, same five-minute install per side.",
      foto:CFG.fotoShard,spin:CFG.spinShard}};
  const SURF={
    raw:{name:"Raw composite",short:"RAW",status:"LAUNCHING FIRST",dev:false,price:"€109",pnote:"PER SET · FIRST DROP · €50 CREDIT",note:"RAW COMPOSITE · MATTE TECHNICAL FINISH",desc:"Early-access prototype run, straight off the machine. Not UV- or scratch-resistant, and not made for temperatures above 33°C or direct sun. The part can deform. In return: every Raw buyer gets €50 off the next painted version."},
    gloss:{name:"Gloss black",short:"GLOSS",status:"IN DEVELOPMENT",dev:true,price:"€220",pnote:"PER SET · PAINTED",note:"DEEP GLOSS BLACK · LAYERED CLEAR COAT",desc:"Hand-painted piano black under a deep gloss seal, sharp reflections, showroom depth. Fully UV-sealed for track weekends."},
    matte:{name:"Matte black",short:"MATTE",status:"IN DEVELOPMENT",dev:true,price:"€220",pnote:"PER SET · PAINTED",note:"STEALTH MATTE BLACK",desc:"Hand-painted and sealed matte, swallows floodlights, pure stealth on the grid. Fully UV-sealed for track weekends."}};
  /* Finnen als eigene Achse (Jonas 09.08.): NUR Raw laesst die Wahl. Painted (gloss/matte)
     gibt es vorerst ausschliesslich mit Finnen - die Option wird dann gar nicht angeboten
     (Button raus, nicht bloss deaktiviert), die Zeile bleibt aber stehen, damit nichts springt. */
  const FINS={fin:{name:"With fins",cap:"With fins"},nofin:{name:"Without fins",cap:"Without fins"}};
  const FIN_CHOICE={raw:true,gloss:false,matte:false};
  /* Bike-datengetrieben (W3): nur die Versionen dieses Bikes (R1=beide, R7=shard, BMW=claw) */
  const KEYS=(CFG.versions&&CFG.versions.length?CFG.versions:["claw","shard"]).filter(k=>VER[k]);
  let curVer=KEYS[0],curSurf="raw",curFins="fin";

  /* Showcase-Bild je Auswahl. Fallback-Kette, damit fehlende Aufnahmen nie ein Loch reissen:
     exakt (ver/surf/fins) -> Raw derselben Finnen-Wahl -> Basis-Foto der Version.
     Neue Painted-Fotos brauchen spaeter nur den Eintrag im JSON-Island, keinen JS-Umbau. */
  function shotFor(ver,surf,fins){
    const m=CFG.shots&&CFG.shots[ver];if(!m)return null;
    return (m[surf]&&m[surf][fins])||(m.raw&&m.raw[fins])||m.base||null;
  }
  function applyShot(){
    const el=document.querySelector('.showcase .shot[data-for="'+curVer+'"]');
    const url=shotFor(curVer,curSurf,curFins);
    if(!el||!url||el.dataset.src===url)return;
    el.dataset.src=url;
    /* Erst tauschen, wenn das Bild da ist - sonst blitzt der leere Rahmen auf */
    const im=new Image();
    im.onload=()=>{if(el.dataset.src===url)el.style.backgroundImage="url('"+url+"')";};
    im.src=url;
  }

  const versEl=$("#vers");
  KEYS.forEach(key=>{
    const v=VER[key],b=document.createElement("button");
    b.className="vpill"+(key===curVer?" sel":"");b.dataset.opt=key;
    b.setAttribute("aria-pressed",key===curVer?"true":"false");
    const showTag=v.tag&&KEYS.length>1; /* FIRST-Badge nur, wenn es eine Wahl gibt */
    b.innerHTML=`${showTag?`<span class="vtag">${v.tag}</span>`:""}<span class="vn">${v.name}</span><span class="vd">${v.sub}</span>`;
    b.addEventListener("click",()=>{
      $$(".vpill").forEach(x=>{x.classList.remove("sel");x.setAttribute("aria-pressed","false");});
      b.classList.add("sel");b.setAttribute("aria-pressed","true");
      if(curVer!==key){curVer=key;spinGlitchT0=performance.now();} /* Glitch nur bei echtem Modell-Wechsel (Jonas 16.07.) */
      render();});
    versEl.appendChild(b);
  });

  function render(){
    const v=VER[curVer],s=SURF[curSurf];
    $$(".showcase .shot").forEach(sh=>sh.classList.toggle("on",sh.dataset.for===curVer));
    /* Jonas 09.08.: aktiv ist nur ClawV2 - ShardV2 wird wie R7/BMW unkenntlich gezeigt */
    if(!CFG.photosPending)R.classList.toggle("pending",curVer==="shard");
    /* Finnen-Zeile: bei Painted bleibt nur die gesetzte Option stehen */
    const canFins=FIN_CHOICE[curSurf]!==false;
    if(!canFins)curFins="fin";
    $$(".fpill").forEach(b=>{
      const on=b.dataset.fin===curFins;
      b.classList.toggle("sel",on);b.setAttribute("aria-pressed",on?"true":"false");
      b.hidden=!canFins&&!on;});
    const lock=$("#finLock");if(lock)lock.hidden=canFins;
    if(!CFG.photosPending)applyShot();
    $("#scName").textContent=v.name;
    /* Bildunterschrift benennt die gewaehlte Version (Jonas 09.08.) */
    const spec=$("#scSpec");if(spec)spec.textContent=`${s.name} · ${FINS[curFins].cap.toLowerCase()}`;
    $("#spinBadge").textContent=v.badge;$("#spinFoto").style.backgroundImage=`url('${v.foto}')`;loadSpin(v.spin);
    $("#selName").textContent=`${v.name} · ${s.name.toLowerCase()}`;
    const st=$("#selStatus");st.textContent=s.status;st.classList.toggle("dev",s.dev);
    /* Ohne Preis (in development) KEIN 30px-Strich rendern (Jonas 13.07.: wirkte kaputt) */
    $("#selPrice").textContent=s.price||"";$("#selPrice").style.display=s.price?"":"none";
    $("#selPriceNote").textContent=s.price?s.pnote:(s.carbon?"REAL CARBON FIBRE · PRICING AT LAUNCH":"PRICING AT LAUNCH");
    $("#selDesc").textContent=s.desc||v.desc;
    /* Mobil kurzer CTA-Text (Jonas 16.07.: langer nowrap-Text sprengte als
       min-content die Layout-Breite — Profil/Finish stehen eh im Namen drueber) */
    /* Zwei Phasen (Jonas 25.07.): vor dem Launch Warteliste, nach dem Launch bei
       Ausverkauf die Back-in-Stock-Benachrichtigung. CFG.launched kommt aus Liquid
       (Produkt-Tag `launched`), damit Konfigurator-CTA und der Waitlist-Block
       unten dieselbe Sprache sprechen. */
    $("#selCta").firstChild.textContent = CFG.launched
      ? (mobile ? "Notify me " : `Notify me · ${v.name} · ${s.name} `)
      : (mobile ? "Join the waitlist " : `Join waitlist · ${v.name} · ${s.name} `);
    /* Waitlist-Tags folgen der Auswahl (Shopify-Kunde bekommt Version+Finish als Tag) */
    const tagEl=$("#wlTags");
    if(tagEl)tagEl.value=CFG.waitTags+", ver-"+curVer+", surf-"+curSurf+", fins-"+curFins;
  }
  $$(".swatch").forEach(b=>b.addEventListener("click",()=>{
    $$(".swatch").forEach(x=>{x.classList.remove("sel");x.setAttribute("aria-pressed","false");});
    b.classList.add("sel");b.setAttribute("aria-pressed","true");curSurf=b.dataset.surf;render();}));
  /* Finnen-Klick: render() setzt sel/aria selbst, damit die Painted-Sperre eine einzige Quelle hat */
  $$(".fpill").forEach(b=>b.addEventListener("click",()=>{
    if(!FIN_CHOICE[curSurf])return;
    curFins=b.dataset.fin;render();}));

  /* Bot-Bremse fuer die Warteliste (Audit 25.07.): Koederfeld + Zeitschwelle.
     Bremst nur Bots, die die Seite wirklich laden - Direkt-POSTs faengt allein
     Shopifys Spamschutz. Stiller Abbruch ist Absicht: ein Bot soll nicht lernen,
     woran er gescheitert ist. */
  const wlT=$("#wlT");
  if(wlT){
    wlT.value=String(Date.now());
    const form=wlT.form;
    if(form)form.addEventListener("submit",e=>{
      const hp=$("#wl-company");
      const zuSchnell=(Date.now()-Number(wlT.value||0))<2500;
      if((hp&&hp.value.trim()!=="")||zuSchnell){e.preventDefault();e.stopPropagation();}
    });
  }

  /* Feste Panel-Masse beim Varianten-/Farb-Klick (Jonas 13.07.: nichts darf springen —
     Desktop-Grid koppelt sonst sogar die Showcase-Hoehe ans Panel): laengste
     Beschreibung + laengsten CTA-Text einmal unsichtbar vermessen, als min-height setzen. */
  function stabilize(){
    const desc=$("#selDesc"),cta=$("#selCta");
    if(!desc||!cta)return;
    const probe=desc.cloneNode(false);
    probe.removeAttribute("id");
    probe.style.cssText="position:absolute;visibility:hidden;pointer-events:none;margin:0;width:"+desc.clientWidth+"px";
    desc.parentElement.appendChild(probe);
    let mx=0;
    Object.values(SURF).forEach(s=>{probe.textContent=s.desc;mx=Math.max(mx,probe.offsetHeight);});
    Object.values(VER).forEach(v=>{probe.textContent=v.desc;mx=Math.max(mx,probe.offsetHeight);});
    probe.remove();
    if(mx)desc.style.minHeight=mx+"px";
    const cprobe=cta.cloneNode(true);
    cprobe.removeAttribute("id");
    cprobe.style.cssText="position:absolute;visibility:hidden;pointer-events:none;margin:0;width:"+cta.clientWidth+"px";
    cta.parentElement.appendChild(cprobe);
    let mc=0;
    KEYS.forEach(k=>Object.keys(SURF).forEach(sk=>{
      cprobe.firstChild.textContent=`Join waitlist · ${VER[k].name} · ${SURF[sk].name} `;
      mc=Math.max(mc,cprobe.offsetHeight);}));
    cprobe.remove();
    if(mc)cta.style.minHeight=mc+"px";
    /* Preiszeile: voller Zustand (raw: Preis+Note+Chip, umbricht auf 2 Zeilen) als
       Mindesthoehe — sonst springt das Panel zwischen raw (81px) und dev (37px) */
    const prow=$(".selinfo .prow");
    if(prow){
      const pprobe=prow.cloneNode(true);
      pprobe.querySelectorAll("[id]").forEach(e=>e.removeAttribute("id"));
      pprobe.style.cssText="position:absolute;visibility:hidden;pointer-events:none;margin:0;min-height:0;width:"+prow.clientWidth+"px";
      const kids=pprobe.children;
      if(kids[0]){kids[0].textContent="€109";kids[0].style.display="";}
      if(kids[1])kids[1].textContent="PER SET · FIRST DROP · €50 CREDIT";
      if(kids[2])kids[2].textContent="LAUNCHING FIRST";
      prow.parentElement.appendChild(pprobe);
      const mp=pprobe.offsetHeight;
      pprobe.remove();
      if(mp)prow.style.minHeight=mp+"px";
    }
  }
  stabilize();
  addEventListener("load",stabilize,{once:true});
  let stTO;addEventListener("resize",()=>{clearTimeout(stTO);stTO=setTimeout(stabilize,200);});

  /* ===== Dreh-Vorschau im Glas-Dock =====
     Perf (Jonas 13.07., Ruckeln): 120 Frames NICHT mehr sofort laden —
     erst wenn das Dock in die Naehe scrollt (rootMargin), damit der
     Seitenstart (LCP/Netz) frei bleibt. */
  const spinEl=$("#spin"),spinCv=$("#spinCv");
  let spinFrames=null,spinOn=true,curSpinBase=null,spinAllowed=false,spinPending=null;
  const spinCache={};
  new IntersectionObserver(es=>{spinOn=es[0].isIntersecting;}).observe(spinEl);
  new IntersectionObserver((es,io)=>{
    if(!es[0].isIntersecting)return;
    io.disconnect();spinAllowed=true;
    if(spinPending)loadSpin(spinPending);
  },{rootMargin:"600px 0px"}).observe(spinEl);
  function loadSpin(base){
    if(!spinAllowed){spinPending=base;spinEl.classList.add("showfoto");return;}
    curSpinBase=base;const N=120;
    const cached=spinCache[base];
    if(cached&&cached.ready){spinFrames=cached;spinEl.classList.remove("showfoto");slast=-1;return;}
    if(!spinFrames)spinEl.classList.add("showfoto");
    if(cached)return;
    const rec={imgs:[],N,ready:false};spinCache[base]=rec;
    const p=new Image();
    p.onload=()=>{
      /* Erst-Frame SOFORT zeigen statt Produktfoto (Jonas 16.07.) */
      if(curSpinBase===base){drawSpinStatic(p);spinEl.classList.remove("showfoto");}
      let ld=0,nx=0;
      const done=()=>{if(++ld>=N){rec.ready=true;
        if(curSpinBase===base){spinFrames=rec;spinEl.classList.remove("showfoto");slast=-1;sizeSpin();
          spinGlitchT0=performance.now();/* verspaeteter Modell-Tausch (Frames kamen erst jetzt) auch mit Glitch kaschieren */}}};
      /* Perf 13.07.: Frames erst NACH window-load und nur 5 parallel statt 120 sofort —
         sonst verdraengen sie LCP/Galerie (Lighthouse-LCP war 21s); solange zeigt der Spin sein Foto */
      const kick=()=>{if(nx>=N)return;const im=new Image();
        im.onload=im.onerror=()=>{done();kick();}; /* einzelne kaputte Frames blocken nicht (Codex 13.07.) */
        im.src=base+"f"+String(nx++).padStart(2,"0")+".webp";rec.imgs.push(im);}; /* Perf 13.07.: WebP */
      const start=()=>{for(let k=0;k<5;k++)kick();};
      if(document.readyState==="complete")start();
      else addEventListener("load",start,{once:true});};
    p.onerror=()=>{delete spinCache[base];if(curSpinBase===base&&!spinFrames)spinEl.classList.add("showfoto");};
    p.src=base+"f00.webp"; /* Perf 13.07.: WebP */
  }
  /* dpr-Cap 2.5 statt 1.25 (Jonas 13.07.: Wing mobil verpixelt) — Canvas ist klein, kostet nichts */
  function sizeSpin(){const r=spinCv.getBoundingClientRect();const dpr=Math.min(mobile?2.5:2,devicePixelRatio||1);spinCv.width=Math.max(2,r.width*dpr);spinCv.height=Math.max(2,r.height*dpr);slast=-1;}
  let spinGlitchT0=-1;const SPIN_GLITCH_MS=650;
  function drawSpinFrame(im,g){
    if(!(im&&im.complete&&im.naturalWidth))return;
    if(spinCv.width<4)sizeSpin();
    const ctx=spinCv.getContext("2d"),cw=spinCv.width,ch=spinCv.height;
    ctx.clearRect(0,0,cw,ch);const s=Math.min(cw/im.naturalWidth,ch/im.naturalHeight),dw=im.naturalWidth*s,dh=im.naturalHeight*s;
    /* Linien-Boost (Jonas 13.07.: mobil kaum sichtbar): Teal-Glow + lighter-Zweitzug */
    ctx.save();
    ctx.shadowColor="rgba(126,232,226,.85)";ctx.shadowBlur=Math.max(3,cw*0.018);
    ctx.drawImage(im,(cw-dw)/2,(ch-dh)/2,dw,dh);
    ctx.globalCompositeOperation="lighter";ctx.globalAlpha=.55;ctx.shadowBlur=0;
    ctx.drawImage(im,(cw-dw)/2,(ch-dh)/2,dw,dh);
    ctx.restore();
    if(g>0){
      /* Glitch beim Modell-Wechsel (Jonas 16.07.): horizontale Slices verschieben
         sich, dazu duenne Teal-/Rot-Risse — klingt ueber ~0.65s ab */
      const n=3+Math.floor(g*5);
      for(let k=0;k<n;k++){
        const sy=Math.random()*ch,shh=Math.max(2,(0.02+Math.random()*0.06)*ch);
        const off=(Math.random()*2-1)*cw*0.07*g;
        ctx.drawImage(spinCv,0,sy,cw,shh,off,sy,cw,shh);
        if(Math.random()<0.4){
          ctx.save();ctx.globalAlpha=0.15*g;ctx.fillStyle=Math.random()<0.5?"#1FB3AA":"#C93227";
          ctx.fillRect(0,sy,cw,Math.max(1,shh*0.3));ctx.restore();
        }
      }
    }
  }
  /* Vor dem Erst-Frame IMMER sizeSpin (Bug 05.08.): Canvas stand noch auf
     Default 300x150 und wurde per CSS quadratisch gestreckt -> verzerrtes Winglet. */
  function drawSpinStatic(im){sizeSpin();drawSpinFrame(im,0);}
  let slast=-1;const SPIN_MS=9000;
  (function spinLoop(t){
    requestAnimationFrame(spinLoop);
    if(!spinOn||reduce||!spinFrames||!spinFrames.ready)return;
    const N=spinFrames.N,i=Math.floor((t/SPIN_MS)*N)%N;
    let g=0;
    if(spinGlitchT0>=0){
      g=Math.max(0,1-(t-spinGlitchT0)/SPIN_GLITCH_MS);
      if(g<=0)spinGlitchT0=-1;
    }
    if(i!==slast||g>0){slast=i;drawSpinFrame(spinFrames.imgs[i],g);}
  })(0);

  render();

  /* ===== Parallax + horizontale Galerie ===== */
  const fin=$("#waitlist"),finPh=$("#finPh");
  const gal=$("#galh"),gTrack=$("#gTrack"),gIdx=$("#gIdx");
  const galMini=gal.classList.contains("gal-mini"); /* R7/BMW: 2 Renders statt 6er-Scrub (Jonas 16.07.) */
  const orbitEl=$("#orbit"),oCards=$$("#orbit .o-card"),oTxts=$$("#orbit .o-txt");
  let gTarget=0,gCur=0,gPhT=0,gPhC=0,galOn=false,gpvCur=0;
  let oZone=0; /* Orbit v4: Zone = welche Karte vorn steht (SWIPE-gewaehlt, 1 Wisch = 1 Schritt) */
  /* v3.3: smoothstep hat an BEIDEN Enden Tempo 0 — ease-out riss mit 3-facher
     Geschwindigkeit an (gemessener Ruck 1.65px/Frame) und kroch dann aus. */
  const smooth=p=>p*p*(3-2*p);
  /* v4 Karussell-Zustand: EIN Winkel + ein Dreh-Tween. Ersetzt oShown/oTxtShown/oA/oTA —
     genau die Uebergabe-Mechanik, die Leerlauf und Bild/Text-Versatz verursacht hat. */
  let oAngCur=0,oTwFrom=0,oTwTo=0,oTwT0=-1;
  /* Masse einmal cachen statt innerWidth/innerHeight in jedem Frame zu lesen */
  let oR2=innerWidth*0.30,oDyF=vh()*0.18,oYBack=-vh()*0.05;
  addEventListener("resize",()=>{oR2=innerWidth*0.30;oDyF=vh()*0.18;oYBack=-vh()*0.05;});
  const gPhs=Array.from(gTrack.querySelectorAll(".ph"));
  const gN=Math.max(1,gTrack.querySelectorAll(".gcard").length-1); /* Raststufen = Fotos-1 */
  new IntersectionObserver(es=>{galOn=es[0].isIntersecting;}).observe(gal);
  let orbitOn=false;
  if(orbitEl)new IntersectionObserver(es=>{orbitOn=es[0].isIntersecting;}).observe(orbitEl);

  /* Swipe-Stepper v5 (Jonas 17.07.): "wehcslöet wenn man horizontal scrollt ...
     so dass vertikal scroll die seite scrollt und horizontal das element".
     Vorher (v3.2/v4) lag die Geste auf der Y-Achse und hat das Seiten-Scrollen per
     preventDefault gekapert — die Buehne fuehlte sich festgepinnt an. Jetzt:
       - Achse wird bei der ersten echten Bewegung EINMAL festgelegt (Lock).
       - y -> wir fassen nichts an, die Seite scrollt nativ (dazu touch-action:pan-y).
       - x -> Karussell, weiterhin 1 Wisch = GENAU 1 Schritt (Rate-Limit 650ms),
         damit harte Wischer nicht durch alle drei springen (Muster 16.07.).
     Das scrollTo-Ausrichten der Buehne ist raus: vertikal gehoert jetzt dem Nutzer. */
  const oBar=$("#oBar"),oFill=$("#oFill");
  const oUpdBar=()=>{if(oFill)oFill.style.transform="translateX("+(oZone*100)+"%)";};
  oUpdBar();
  if(mobile&&orbitEl){
    let sX=null,sY=null,sAxis=null,sStepped=false,sLock=0;
    const inStage=()=>{const r=orbitEl.getBoundingClientRect();return r.top<=vh()*0.35&&r.bottom>=vh()*0.65;};
    addEventListener("touchstart",e=>{
      if(!inStage()){sX=null;sY=null;return;}
      sX=e.touches[0].clientX;sY=e.touches[0].clientY;sAxis=null;sStepped=false;
    },{passive:true});
    addEventListener("touchmove",e=>{
      if(sX===null||!inStage())return;
      const dx=e.touches[0].clientX-sX,dy=e.touches[0].clientY-sY;
      if(sAxis===null){
        if(Math.abs(dx)<6&&Math.abs(dy)<6)return;      /* noch zu klein zum Entscheiden */
        sAxis=Math.abs(dx)>Math.abs(dy)?"x":"y";       /* einmal festlegen, nicht mittendrin kippen */
      }
      if(sAxis==="y")return;                           /* vertikal: Finger weg, Seite scrollt */
      if(e.cancelable)e.preventDefault();              /* horizontal: gehoert dem Karussell */
      const fwd=dx<0;                                  /* nach links wischen = naechste Karte */
      const now=performance.now();
      if(!sStepped&&Math.abs(dx)>40&&now-sLock>650){
        sStepped=true;sLock=now;
        oZone=Math.max(0,Math.min(2,oZone+(fwd?1:-1)));
        oUpdBar();
        if(oBar)oBar.classList.add("used");            /* Hinweis raus, Balken bleibt */
      }
    },{passive:false});
    addEventListener("touchend",()=>{sX=null;sY=null;sAxis=null;},{passive:true});
  }

  /* SVG-Leitlinie: webt sich durch die Karten; Skizzen = Hidden-Line-Renders,
     laden sich beim Vorbeiziehen des Lichtpulses auf. */
  const gLine=$("#gLine"),gLineF=$("#gLineF");
  const SKIMG=CFG.sketches;
  let gPath=null,gLen=0,gSks=[],gTrail=[];
  function buildGline(){
    if(!gLine||!gLineF||galMini)return; /* Mini-Galerie: keine Leitlinie */
    gLine.innerHTML="";gLineF.innerHTML="";gSks=[];
    const cards=Array.from(gTrack.querySelectorAll(".gcard"));
    if(!cards.length)return;
    const gTop=gLine.getBoundingClientRect().top-gTrack.getBoundingClientRect().top;
    const yOf=el=>el.offsetTop-gTop;
    const W=gLine.clientWidth||10,H=gLine.clientHeight||10;
    gLine.setAttribute("viewBox",`0 0 ${W} ${H}`);
    gLineF.setAttribute("viewBox",`0 0 ${W} ${H}`);
    const pts=[],rects=[];
    const first=cards[0];
    const yMid=yOf(first)+first.offsetHeight/2;
    pts.push([first.offsetLeft-160,yMid]);
    cards.forEach((c,i)=>{
      const x0=c.offsetLeft,w=c.offsetWidth,h=c.offsetHeight,y0=yOf(c);
      const above=i%2===0;
      const crest=above?y0-56:y0+h+56;
      pts.push([x0+w/2,crest]);
      if(i%2===1)rects.push([x0-4,y0-4,w+8,h+8]);
      const iw=236,ih=147;
      const iy=above?y0+h+26:y0-ih-26;
      gSks.push({href:SKIMG[i%SKIMG.length],
        ix:x0+w/2-iw/2,iy,iw,ih,x:x0+w/2,y:iy+ih/2,e:0,g:null});
      if(i===cards.length-1)pts.push([x0+w+160,yMid]);
    });
    let d=`M ${pts[0][0].toFixed(1)} ${pts[0][1].toFixed(1)}`;
    for(let i=1;i<pts.length;i++){const[x,y]=pts[i],[px,py]=pts[i-1];const mx=(px+x)/2;
      d+=` C ${mx.toFixed(1)} ${py.toFixed(1)}, ${mx.toFixed(1)} ${y.toFixed(1)}, ${x.toFixed(1)} ${y.toFixed(1)}`;}
    gSks.forEach(s=>{
      const im=document.createElementNS(NS,"image");
      im.setAttribute("href",s.href);
      im.setAttribute("x",s.ix.toFixed(1));im.setAttribute("y",s.iy.toFixed(1));
      im.setAttribute("width",s.iw);im.setAttribute("height",s.ih);
      im.style.opacity="0.16";
      gLine.appendChild(im);s.g=im;
    });
    gPath=document.createElementNS(NS,"path");gPath.setAttribute("d",d);
    gPath.setAttribute("fill","none");gPath.setAttribute("stroke","none");
    gLine.appendChild(gPath);
    gLen=gPath.getTotalLength();
    /* R20 Perf: kurze Segmente statt stroke-dashoffset auf dem Riesen-Pfad */
    const TRAIL=mobile?[{len:64,off:0,op:1}]
      :[{len:46,off:0,op:1},{len:92,off:56,op:.32},{len:170,off:160,op:.10}];
    gTrail=[];
    function mkTrail(host){
      TRAIL.forEach(t=>{const p=document.createElementNS(NS,"path");
        p.setAttribute("class","pulse");p.setAttribute("d","M -10 -10");
        p.style.opacity=String(t.op);
        host.appendChild(p);gTrail.push({el:p,off:t.off,len:t.len});});
    }
    mkTrail(gLine);
    const mask=document.createElementNS(NS,"mask");mask.setAttribute("id","gm");
    rects.forEach(r=>{const rc=document.createElementNS(NS,"rect");
      rc.setAttribute("x",r[0].toFixed(1));rc.setAttribute("y",r[1].toFixed(1));
      rc.setAttribute("width",r[2].toFixed(1));rc.setAttribute("height",r[3].toFixed(1));
      rc.setAttribute("fill","#fff");mask.appendChild(rc);});
    gLineF.appendChild(mask);
    const gf=document.createElementNS(NS,"g");gf.setAttribute("mask","url(#gm)");
    mkTrail(gf);
    gLineF.appendChild(gf);
    if(reduce){gSks.forEach(s=>s.g.style.opacity="0.3");gTrail.forEach(t=>t.el.style.display="none");}
  }
  buildGline();
  addEventListener("resize",buildGline);
  function trailSeg(a,b){
    a=Math.max(0,a);b=Math.min(gLen,b);
    if(!gPath||b-a<2)return "M -10 -10";
    let d="";
    for(let l=a;l<b;l+=12){const pt=gPath.getPointAtLength(l);
      d+=(d?" L ":"M ")+pt.x.toFixed(1)+" "+pt.y.toFixed(1);}
    const pe=gPath.getPointAtLength(b);d+=" L "+pe.x.toFixed(1)+" "+pe.y.toFixed(1);
    return d;
  }

  /* Mobil: NATIVES Snap-Scrollen (Jonas 16.07.: JS-Gesten fuehlten sich auf
     iOS kaputt an) — der Browser rastet selbst weich ein, Index folgt dem Scroll. */
  if(mobile){
    const gCards=$$(".gcard",gTrack);
    let gTick=false;
    gTrack.addEventListener("scroll",()=>{
      if(gTick)return;gTick=true;
      requestAnimationFrame(()=>{gTick=false;
        const mid=gTrack.scrollLeft+gTrack.clientWidth/2;
        let best=0,bd=1e9;
        gCards.forEach((c,i)=>{const d=Math.abs(c.offsetLeft+c.offsetWidth/2-mid);if(d<bd){bd=d;best=i;}});
        gIdx.textContent="0"+(best+1)+" / 0"+gCards.length;
      });
    },{passive:true});
  }
  (function galRaf(t){
    const k=(shoot||reduce)?1:0.09;
    if(!mobile&&!galMini&&(galOn||Math.abs(gTarget-gCur)>0.1||Math.abs(gPhT-gPhC)>0.1)){
      gCur+=(gTarget-gCur)*k;gPhC+=(gPhT-gPhC)*k;
      gTrack.style.transform=`translateX(${(-gCur).toFixed(1)}px)`;
      for(const ph of gPhs)ph.style.transform=`translateX(${gPhC.toFixed(1)}px)`;
    }
    if(galOn&&gTrail.length&&gLen>0&&!reduce){
      /* Desktop: Linie folgt dem KARTEN-Fortschritt (gCur) statt dem rohen
         Sektions-Scroll — war sonst fertig, bevor man rechts ankommt (Jonas
         13.07. abends). Mobil (Pager) weiter zeitlich ueber den Sektions-Scroll. */
      const gMax=gTrack.scrollWidth-innerWidth+innerWidth*0.08;
      const pos=(mobile?easeO(gpvCur):clamp(gMax>0?gCur/gMax:0,0,1))*Math.max(1,gLen-140);
      const segCache={};
      for(const tr of gTrail){const key=tr.off+"_"+tr.len;
        const d=segCache[key]||(segCache[key]=trailSeg(pos-tr.off-tr.len,pos-tr.off));
        if(d!==tr.lastD){tr.lastD=d;tr.el.setAttribute("d",d);}}
      let tip=null;
      try{tip=gPath.getPointAtLength(Math.max(0,pos-20));}catch(e){}
      if(tip)for(const s of gSks){
        const prox=clamp(1-Math.hypot(s.x-tip.x,s.y-tip.y)/300,0,1);
        s.e=Math.max(s.e*0.968,prox);
        const op=(0.16+0.84*s.e).toFixed(3);
        if(op!==s.lastOp){s.g.style.opacity=op;s.lastOp=op;}
      }
    }
    if(orbitOn){
      /* v4 KARUSSELL (Jonas 17.07.: "das kreisen und nach vorne kommen wird einfach nix").
         Gemessen am alten Konzept: 26.9% der Zeit stand NICHTS vorn (Luecken bis 1.27s)
         und in 56.4% der Zeit passte das vordere Bild nicht zum sichtbaren Text —
         weil Bilder auf einem Timer liefen, der Text aber am Wisch hing.

         Jetzt: EIN Ring, EIN Winkel, EINE Quelle. Ein Wisch dreht den Ring um 120°,
         wer vorn durchlaeuft ist automatisch am groessten. Es gibt keinen Flug, keine
         Uebergabe-Regel und keinen Timer mehr — also strukturell nichts, was ruckeln,
         leerlaufen oder auseinanderlaufen kann. Bild UND Text folgen demselben Winkel,
         darum passen sie per Konstruktion immer zusammen. */
      const OSTEP=Math.PI*2/3;              /* 3 Karten = 120° Abstand */
      const oAim=-oZone*OSTEP;              /* Zielwinkel: Karte oZone steht vorn */
      if(oTwTo!==oAim){oTwFrom=oAngCur;oTwTo=oAim;oTwT0=t;} /* neuer Wisch -> Dreh-Tween */
      const tw=oTwT0<0?1:clamp((t-oTwT0)/760,0,1);
      oAngCur=oTwFrom+(oTwTo-oTwFrom)*smooth(tw); /* smoothstep: Tempo 0 an beiden Enden */

      oCards.forEach((c,k2)=>{
        const ph=oAngCur+k2*OSTEP;
        const dp=(Math.cos(ph)+1)/2;        /* 1 = vorn, 0.25 = hinten (bei ±120°) */
        const x=Math.sin(ph)*oR2*1.1;
        const y=oYBack+(oDyF-oYBack)*dp;    /* vorn tiefer (Text unten bleibt frei) */
        const s=0.30+0.58*dp;
        /* translate3d = eigener GPU-Layer. Das calc(-50%) MUSS bleiben: .o-card haengt
           an left:50%/top:26% und wird erst dadurch zentriert (sonst Versatz um eine
           halbe Karte). */
        const tf=`translate3d(calc(-50% + ${x.toFixed(1)}px),calc(-50% + ${y.toFixed(1)}px),0) scale(${s.toFixed(3)})`;
        if(c._tf!==tf){c._tf=tf;c.style.transform=tf;}
        const op=(0.5+0.5*dp).toFixed(3);
        if(c._op!==op){c._op=op;c.style.opacity=op;}
        const zi=Math.round(10+dp*20);      /* vorn immer oben, ohne Sprung-Regel */
        if(c._zi!==zi){c._zi=zi;c.style.zIndex=zi;}
      });
      /* Text aus DEMSELBEN Winkel: sichtbar nur, wenn seine Karte vorn ist.
         Bei ±60° ist er auf 0 — der alte ist also weg, bevor der neue kommt
         (keine Ueberschneidung, wie am 17.07. gewuenscht). */
      oTxts.forEach((tx,k2)=>{
        let pw=(oAngCur+k2*OSTEP)%(Math.PI*2);
        if(pw>Math.PI)pw-=Math.PI*2; if(pw<-Math.PI)pw+=Math.PI*2;
        const a=smooth(clamp(1-Math.abs(pw)/(Math.PI/3),0,1));
        const op=a.toFixed(3);
        if(tx._op!==op){tx._op=op;tx.style.opacity=op;
          tx.style.transform=`translate3d(0,${((1-a)*22).toFixed(1)}px,0)`;}
      });
    }
    requestAnimationFrame(galRaf);
  })(0);
  function prog(sec){const r=sec.getBoundingClientRect();return clamp(-r.top/(r.height-vh()),0,1);}

  function frame(){
    ticking=false;
    /* Finale-Parallax */
    const fr=fin.getBoundingClientRect();
    if(fr.top<vh()&&fr.bottom>0){const pf=clamp(1-fr.top/vh(),0,1.6);
      finPh.style.transform=`translateY(${((pf-0.8)*34).toFixed(1)}px)`;}
    /* Galerie-Track */
    const gpv=prog(gal);gpvCur=gpv;
    /* Einrasten pro Foto (Jonas 13.07.): Raststufen statt durchgehendem Scrub.
       Mobil uebernimmt der Ein-Wisch-Pager (MCD.pager) Transform + Index. */
    if(!mobile&&!galMini){
      /* Desktop LINEAR statt Raststufen (Jonas 13.07. spaet: Haltefenster
         fuehlten sich wie Scroll-Sperre an; Rasten nur mobil im Pager) */
      const gq=gpv;
      gTarget=gq*(gTrack.scrollWidth-innerWidth+innerWidth*0.08);
      gPhT=(gq-0.5)*26;
      gIdx.textContent="0"+(1+Math.min(gN,Math.round(gq*gN)))+" / 0"+(gN+1);
    }
    /* Bild-Parallax — mobil AUS (Jonas 13.07.: Scroll wirkt niedrig-fps; die
       Scroll-gebundenen Style-Writes sind mobil der Hauptverdaechtige) */
    if(!mobile)$$('.pfx[data-vis="1"]').forEach(el=>{
      const r=el.getBoundingClientRect();
      const p=clamp(1-r.top/vh(),0,1);
      el.style.transform=`translateY(${((p-0.5)*30).toFixed(1)}px)`;});
  }
  const ioP=new IntersectionObserver(es=>es.forEach(e=>e.target.dataset.vis=e.isIntersecting?"1":""),{threshold:0});
  $$(".pfx").forEach(el=>ioP.observe(el));
  frame();
})();
